import { useWeb3React } from '@web3-react/core';
import { providers } from 'ethers';

export function useProvider(): providers.Web3Provider | void {
  const { library } = useWeb3React();
  return library;
}
